/* Speed Cleaning custom cart drawer (Claude). Markup: sections/sc-cart-drawer.liquid */
(function () {
  if (window.SCDrawer) return;
  if (!document.getElementById('sc-drawer-root')) return;
  // Other scripts can re-render the footer section group and replace our markup,
  // so always look the drawer up fresh instead of holding on to one element.
  function R() { return document.getElementById('sc-drawer-root'); }
  function P() { var r = R(); return r && r.querySelector('.sc-panel'); }

  var CFG = window.SCDrawerConfig || {};
  var BASE = (CFG.root || '/').replace(/\/?$/, '/');
  var CART_URL = CFG.cartUrl || '/cart';
  var SECTION = R().getAttribute('data-sc-section');
  var BUBBLES = ['cart-icon-bubble', 'mobile-cart-icon-bubble'];
  var HDR = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-SC-Drawer': '1' };
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var origFetch = window.fetch.bind(window);
  var SC = window.SCDrawer = { enabled: true, isOpen: false };

  var lastFocus = null, refreshTimer = null, pendingOpen = false, giftBusy = false, giftFailed = false;
  var viewed = {}, shownTimer = null, needTimer = null;

  function dl(evt, data) {
    try { window.dataLayer = window.dataLayer || []; data = data || {}; data.event = evt; window.dataLayer.push(data); } catch (e) {}
  }
  function content() { var r = R(); return r && r.querySelector('[data-sc-content]'); }
  function sectionsParam() { return [SECTION].concat(BUBBLES).join(','); }
  function setBusy(on) { var p = P(); if (p) p.classList.toggle('is-busy', !!on); }
  function showErr(msg) {
    var el = R() && R().querySelector('[data-sc-err]');
    if (!el) return;
    if (msg) { el.textContent = msg; el.hidden = false; } else { el.hidden = true; el.textContent = ''; }
  }
  function isSubGift(i) { return !!(i.properties && i.properties._appstle_parent_product); }

  /* ---------- one cart update at a time ---------- */
  // Every change goes through this queue so two clicks (or a click and a gift fix-up)
  // never race each other with out-of-date line keys.
  var queue = Promise.resolve(), pending = 0;
  function enqueue(fn) {
    pending++; setBusy(true); showErr('');
    var run = queue.then(fn, fn);
    queue = run.catch(function () {}).then(function () { pending--; if (!pending) setBusy(false); });
    return run;
  }

  /* ---------- render ---------- */
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function apply(sections) {
    if (!sections) return;
    var html = sections[SECTION];
    if (html) {
      var fresh = parse(html).querySelector('[data-sc-content]');
      var cur = content();
      if (fresh && cur) {
        var sc = cur.querySelector('.sc-scroll'), top = sc ? sc.scrollTop : 0;
        cur.replaceWith(document.importNode(fresh, true));
        var nsc = R().querySelector('.sc-scroll'); if (nsc) nsc.scrollTop = top;
      }
    }
    BUBBLES.forEach(function (id) {
      if (!sections[id]) return;
      var n = parse(sections[id]).getElementById(id);
      if (!n) return;
      document.querySelectorAll('#' + id).forEach(function (el) { el.replaceWith(document.importNode(n, true)); });
    });
    afterRender();
  }
  function renderNow() {
    return origFetch(BASE + '?sections=' + sectionsParam(), { headers: { 'X-SC-Drawer': '1' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(apply);
  }
  function refresh(openAfter) {
    if (openAfter) pendingOpen = true;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      renderNow()
        .then(function () { if (pendingOpen) { pendingOpen = false; open(); } })
        .catch(function () { if (pendingOpen) { pendingOpen = false; window.location.href = CART_URL; } });
    }, 60);
  }

  // Raw request. With render (default) the response's sections are applied.
  function post(path, body, opts) {
    opts = opts || {};
    if (!opts.noRender) { body.sections = sectionsParam(); body.sections_url = window.location.pathname; }
    return origFetch(BASE + path, { method: 'POST', headers: HDR, body: JSON.stringify(body), credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { if (!opts.noRender) apply(j.sections); return j; });
  }
  function fetchCart() {
    return origFetch(BASE + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function friendlyError() {
    showErr('Sorry, that didn’t update. Please try again.');
    return renderNow().catch(function () {});
  }

  // cart/change.js without rendering. If the line key went stale, find the line again and retry once.
  function changeRaw(body) {
    return post('cart/change.js', body, { noRender: true }).catch(function (err) {
      var msg = (err && (err.description || err.message)) || '';
      if (!body.id || !/valid id|line parameter|not found/i.test(msg)) throw err;
      return fetchCart().then(function (cart) {
        var vid = String(body.id).split(':')[0];
        var same = cart.items.filter(function (i) { return String(i.variant_id) === vid && !isSubGift(i); });
        if (same.length !== 1) throw err;
        body.id = same[0].key;
        return post('cart/change.js', body, { noRender: true });
      });
    });
  }

  // After any line change: keep Appstle's subscriber gift in step with the cart, then render ONCE.
  // No subscription left -> take the gift out. Subscription but no gift -> add it with Appstle's
  // properties so Appstle's "Subscription Free Product" discount makes it $0.
  function syncSubGiftAndRender(cart) {
    var c = content();
    var gv = c ? +(c.dataset.subgiftVariant || 0) : 0;
    var sub = cart.items.filter(function (i) { return i.selling_plan_allocation; })[0];
    var gifts = cart.items.filter(isSubGift);
    if (!sub && gifts.length) {
      var u = {}; gifts.forEach(function (g) { u[g.key] = 0; });
      dl('sc_subgift_removed', {});
      return post('cart/update.js', { updates: u });
    }
    if (sub && !gifts.length && gv) {
      dl('sc_subgift_added', {});
      return post('cart/add.js', { items: [{ id: gv, quantity: 1, properties: {
        _appstle_parent_product: String(sub.variant_id),
        _appstle_parent_selling_plan: String(sub.selling_plan_allocation.selling_plan.id)
      } }] });
    }
    return renderNow();
  }
  function lineChange(body) {
    return enqueue(function () {
      return changeRaw(body).then(syncSubGiftAndRender).catch(friendlyError);
    });
  }

  /* ---------- gift + tracking after every render ---------- */
  function afterRender() {
    var c = content(); if (!c) return;
    var d = c.dataset;
    // Landing-page layout has its own slim header; keep its cart count in step.
    var hdr = document.querySelector('.sclp-hdr a.cart');
    if (hdr) {
      var n = +d.count || 0, ct = hdr.querySelector('.ct');
      if (n && !ct) { hdr.appendChild(document.createTextNode(' ')); ct = document.createElement('span'); ct.className = 'ct'; hdr.appendChild(ct); }
      if (ct) { if (n) ct.textContent = n; else ct.remove(); }
    }
    if (!giftBusy && !giftFailed && d.giftVariant) {
      var elig = d.giftEligible === 'true', key = d.giftKey, qty = parseInt(d.giftQty || '0', 10);
      var job = null;
      if (elig && !key) {
        job = function () { return post('cart/add.js', { items: [{ id: +d.giftVariant, quantity: 1, properties: { _sc_source: 'reward_gift' } }] }).then(function () { dl('sc_gift_unlocked', { sc_cart_value: +d.eligible / 100 }); }); };
      } else if (!elig && key) {
        job = function () { return changeRaw({ id: key, quantity: 0 }).then(renderNow); };
      } else if (elig && qty > 1) {
        job = function () { return changeRaw({ id: key, quantity: 1 }).then(renderNow); };
      }
      if (job) {
        giftBusy = true;
        enqueue(job).catch(function () { giftFailed = true; }).then(function () { giftBusy = false; });
      }
    }
    // Safety nets for cart changes made outside the drawer (e.g. the theme's /cart page or an app).
    var orphan = c.querySelector('[data-sc-orphan]');
    var need = c.querySelector('[data-sc-needgift]');
    if ((orphan || need) && !needTimer && !giftBusy) {
      needTimer = setTimeout(function () {
        needTimer = null;
        if (giftBusy || pending) return;
        enqueue(function () { return fetchCart().then(function (cart) {
          var hasSub = cart.items.some(function (i) { return i.selling_plan_allocation; });
          var hasGift = cart.items.some(isSubGift);
          if (hasSub === hasGift) return;
          return syncSubGiftAndRender(cart);
        }); }).catch(function () {});
      }, need ? 1500 : 0); // product pages: give Appstle a moment to add the gift itself
    }
    if (SC.isOpen) trackViews();
  }

  function trackViews() {
    var c = content(); if (!c) return;
    var shown = (c.dataset.shown || '').split('|').filter(Boolean);
    var changed = false;
    c.querySelectorAll('[data-sc-card]').forEach(function (card) {
      var v = card.dataset.variant, rule = card.dataset.rule, k = v + '~' + rule;
      if (!viewed[k]) {
        viewed[k] = 1;
        dl('sc_addon_view', { sc_variant_id: v, sc_product: card.dataset.product, sc_rule: rule, sc_pos: +card.dataset.pos, sc_price: +card.dataset.price / 100, sc_unlock_badge: card.classList.contains('hot') });
      }
      if (shown.indexOf(k) < 0) { shown.push(k); changed = true; }
    });
    if (changed) {
      c.dataset.shown = shown.slice(-60).join('|');
      clearTimeout(shownTimer);
      shownTimer = setTimeout(function () {
        var cur = content();
        post('cart/update.js', { attributes: { _sc_shown: cur ? cur.dataset.shown : '' } }, { noRender: true }).catch(function () {});
      }, 800);
    }
  }

  /* ---------- open / close ---------- */
  function open() {
    if (SC.isOpen) { trackViews(); return; }
    SC.isOpen = true;
    lastFocus = document.activeElement;
    document.documentElement.classList.add('sc-open', 'sc-lock');
    if (R()) R().setAttribute('aria-hidden', 'false');
    setTimeout(function () { var p = P(); if (p) p.focus({ preventScroll: true }); }, 30);
    var c = content();
    dl('sc_drawer_open', { sc_cart_value: c ? +c.dataset.total / 100 : 0 });
    trackViews();
  }
  function close() {
    if (!SC.isOpen) return;
    SC.isOpen = false;
    document.documentElement.classList.remove('sc-open', 'sc-lock');
    if (R()) R().setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  SC.open = open; SC.close = close; SC.refresh = refresh;

  /* ---------- drawer clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('#sc-drawer-root')) return;
    if (t.closest('[data-sc-close]')) { e.preventDefault(); close(); return; }

    var q = t.closest('[data-sc-qty]');
    if (q) { lineChange({ id: q.dataset.key, quantity: Math.max(0, +q.dataset.q) }); return; }

    var plan = t.closest('[data-sc-plan]');
    if (plan) {
      if (plan.getAttribute('aria-pressed') === 'true') return;
      var pid = plan.dataset.scPlan;
      // Flip the buttons right away so the tap feels instant.
      plan.parentNode.querySelectorAll('[data-sc-plan]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === plan)); });
      lineChange({ id: plan.dataset.key, quantity: +plan.dataset.q, selling_plan: pid ? +pid : null });
      dl('sc_subscribe_toggle', { sc_mode: pid ? 'subscribe' : 'one_time' });
      return;
    }

    var add = t.closest('[data-sc-add]');
    if (add) {
      var card = add.closest('[data-sc-card]');
      var info = { sc_variant_id: card.dataset.variant, sc_product: card.dataset.product, sc_rule: card.dataset.rule, sc_pos: +card.dataset.pos, sc_price: +card.dataset.price / 100, sc_unlock_badge: card.classList.contains('hot') };
      var props = { _sc_source: 'drawer_addon', _sc_rule: card.dataset.rule, _sc_pos: card.dataset.pos };
      enqueue(function () {
        return post('cart/add.js', { items: [{ id: +card.dataset.variant, quantity: 1, properties: props }] })
          .then(function () { dl('sc_addon_add', info); });
      }).catch(friendlyError);
      return;
    }

    var prot = t.closest('[data-sc-protect]');
    if (prot) {
      var d = content().dataset;
      if (prot.getAttribute('aria-checked') === 'true' && d.protKey) {
        prot.setAttribute('aria-checked', 'false');
        lineChange({ id: d.protKey, quantity: 0 });
        dl('sc_protection_toggle', { sc_on: false });
      } else if (d.protVariant) {
        prot.setAttribute('aria-checked', 'true');
        enqueue(function () { return post('cart/add.js', { items: [{ id: +d.protVariant, quantity: 1, properties: { _sc_source: 'protection' } }] }); }).catch(friendlyError);
        dl('sc_protection_toggle', { sc_on: true });
      }
      return;
    }

    var tipBtn = t.closest('[data-sc-info]');
    if (tipBtn) {
      var tip = tipBtn.closest('.sc-protect').querySelector('.sc-tip');
      var openTip = !tip.classList.contains('open');
      tip.classList.toggle('open', openTip);
      tipBtn.setAttribute('aria-expanded', String(openTip));
      return;
    }

    var pro = t.closest('[data-sc-pro]');
    if (pro) dl('sc_pro_link_click', { sc_link: pro.dataset.scPro });
  });

  document.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('#sc-drawer-root [data-sc-freq]');
    if (f) lineChange({ id: f.dataset.key, quantity: +f.dataset.q, selling_plan: +f.value });
  });

  document.addEventListener('submit', function (e) {
    if (!e.target.closest || !e.target.closest('#sc-drawer-root [data-sc-checkout]')) return;
    var c = content();
    dl('sc_checkout', { sc_cart_value: c ? +c.dataset.total / 100 : 0, sc_items: c ? +c.dataset.count : 0 });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && SC.isOpen) close(); });

  /* ---------- hooks into the theme and apps ---------- */
  // Stop the theme's "go to /cart page" redirect after add to cart; open the drawer instead.
  window.addEventListener('eurus:cart:redirect', function (e) { e.stopImmediatePropagation(); e.stopPropagation(); refresh(true); }, true);
  document.addEventListener('eurus:cart:items-changed', function () { refresh(false); });

  // Cart icon / cart links open the drawer.
  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var a = e.target.closest && e.target.closest('#cart-icon, a[href="' + CART_URL + '"], a[href$="/cart"]');
    if (!a || a.closest('#sc-drawer-root')) return;
    e.preventDefault(); e.stopPropagation();
    open();
  }, true);

  // Any cart change made by the theme or an app (fetch or XHR) refreshes the drawer; adds also open it.
  function isOwn(init) {
    var h = init && init.headers;
    if (!h) return false;
    if (typeof h.get === 'function') return !!h.get('X-SC-Drawer');
    return !!(h['X-SC-Drawer'] || h['x-sc-drawer']);
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
    var p = origFetch(input, init);
    if (CART_RE.test(url) && !isOwn(init)) {
      var isAdd = /\/cart\/add/.test(url);
      p.then(function (r) { if (r && r.ok) refresh(isAdd); }).catch(function () {});
    }
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this._scUrl = String(u || ''); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (x._scUrl && CART_RE.test(x._scUrl)) {
      x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) refresh(/\/cart\/add/.test(x._scUrl)); });
    }
    return xSend.apply(this, arguments);
  };

  // Landing pages (layout/landing.liquid sets SC_FORM_INTERCEPT): their buy buttons are plain forms
  // that would go to the cart page. Add the item in the background and open the drawer instead.
  // If anything goes wrong, fall back to the normal form submit so the sale is never lost.
  if (window.SC_FORM_INTERCEPT) {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (e.defaultPrevented || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
      if (f.closest('#sc-drawer-root')) return;
      e.preventDefault();
      var btn = f.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
      var fd = new FormData(f), added = false;
      enqueue(function () {
        return origFetch(BASE + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-SC-Drawer': '1' }, credentials: 'same-origin' })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; added = true; return j; }); })
          .then(function () { open(); return fetchCart(); }) // open now; the orange bar shows while it fills in
          .then(syncSubGiftAndRender);
      }).then(function () { if (btn) btn.disabled = false; }, function () {
        if (btn) btn.disabled = false;
        if (added) window.location.href = CART_URL; // item is in the cart; just show the cart page
        else HTMLFormElement.prototype.submit.call(f); // add failed; let the normal form try
      });
    });
  }

  // Back button from checkout (bfcache) shows a stale cart; refresh it.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(false); });

  afterRender();
})();
